import { trackPageInteraction } from "@asosteam/asos-content-web-analytics";
import analyticsProvider from "./analyticsProvider";

export const trackCTAInteraction = async (eventName, props) => {
  try {
    const config = await analyticsProvider(eventName, props);
    trackPageInteraction(config);
  } catch (e) {
    throw new Error(e);
  }
};
